import { Types } from './types';

export interface ConnectivityState {
  online: boolean;
}

const initialState: ConnectivityState = {
  online: true
};

export interface ConnectivityActionPayload {
  type: Types;
  payload: ConnectivityState;
}

const connectivityReducer = (
  state = initialState,
  action: ConnectivityActionPayload
): ConnectivityState => {
  if (action.type === Types.CONNECTIVITY_SET_CONNECTION) {
    return {
      ...state,
      online: action.payload.online
    };
  } else {
    return {
      ...state
    };
  }
};

export default connectivityReducer;
